import { Role } from 'src/Enum/Report';

type UserRole = {
  N_ROLE: string;
};

export const determineRole = (
  cvupApproverRole: UserRole | undefined,
  cvupCreatorRole: UserRole | undefined
) => {
  if (cvupApproverRole) return Role.APPROVER;
  if (cvupCreatorRole) return Role.CREATOR;

  return Role.NONE;
};
